import s from "./td-longtail-vue-components197.js";
/* empty css                              */
import a from "./td-longtail-vue-components98.js";
var c = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("div", { staticClass: "cart-sticky" }, [i("div", { staticClass: "cart-sticky__prices" }, [t.price ? i(t.Prices, { attrs: { "is-price": t.price, "was-price": t.wasPrice, theme: "light", "post-text-is-price": t.priceMonthly && !t.wasPrice ? "einmalig" : "", "post-text-was-price": t.priceMonthly && t.wasPrice ? "einmalig" : "" } }) : e._e(), t.priceMonthly ? i(t.Prices, { attrs: { "is-price": t.priceMonthly, "was-price": t.wasPriceMonthly, theme: "light", "post-text-is-price": t.wasPriceMonthly ? "" : "monatlich", "post-text-was-price": t.wasPriceMonthly ? "monatlich" : "" } }) : e._e()], 1), i("div", { staticClass: "cart-sticky__add-to-cart" }, [e._t("addToCart", function() {
    return [i(t.AddToCartButton, { attrs: { "display-icon": "", "display-text": !1, theme: "light" }, on: { "add-to-cart": (r) => e.$emit("add-to-cart", r) } })];
  }), e._t("addToCartContent")], 2)]);
}, o = [], n = /* @__PURE__ */ a(
  s,
  c,
  o,
  !1,
  null,
  "4d115b49"
);
const m = n.exports;
export {
  m as default
};
